/**
 * @generated SignedSource<<c281033314b8e57b7b74b1a2e655f1ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useChargesRelayByIdQuery$variables = {
  id: string;
};
export type useChargesRelayByIdQuery$data = {
  readonly getCharge: {
    readonly amount: number | null | undefined;
    readonly amountRefunded: number | null | undefined;
    readonly chargeTotal: any | null | undefined;
    readonly created: any | null | undefined;
    readonly data: any | null | undefined;
    readonly description: string | null | undefined;
    readonly holdAmount: number | null | undefined;
    readonly id: string;
    readonly organizationId: string | null | undefined;
    readonly partnerCharge: boolean | null | undefined;
    readonly paymentIntentId: string | null | undefined;
    readonly refundStatus: string | null | undefined;
    readonly refunded: boolean | null | undefined;
    readonly refunds: ReadonlyArray<{
      readonly amount: number;
      readonly createdOn: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly status: string;
    }>;
    readonly rental: {
      readonly id: string;
    } | null | undefined;
    readonly status: string | null | undefined;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string | null | undefined;
    readonly taxAmount: any | null | undefined;
    readonly taxRate: any | null | undefined;
    readonly user: {
      readonly email: string | null | undefined;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
      readonly phone: string;
    } | null | undefined;
    readonly userId: string | null | undefined;
    readonly userOldId: string | null | undefined;
    readonly wallet: {
      readonly id: string;
    } | null | undefined;
    readonly walletId: string | null | undefined;
    readonly walletTransaction: {
      readonly id: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useChargesRelayByIdQuery = {
  response: useChargesRelayByIdQuery$data;
  variables: useChargesRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v6 = [
  (v1/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Charge",
    "kind": "LinkedField",
    "name": "getCharge",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountRefunded",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chargeTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "holdAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentIntentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refundStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refunded",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "walletId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "partnerCharge",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Rental",
        "kind": "LinkedField",
        "name": "rental",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserWallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletTransaction",
        "kind": "LinkedField",
        "name": "walletTransaction",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Refund",
        "kind": "LinkedField",
        "name": "refunds",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChargesRelayByIdQuery",
    "selections": (v7/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useChargesRelayByIdQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "ffe6494c0281362f50f25d1eed67aaee",
    "id": null,
    "metadata": {},
    "name": "useChargesRelayByIdQuery",
    "operationKind": "query",
    "text": "query useChargesRelayByIdQuery(\n  $id: ID!\n) {\n  getCharge(id: $id) {\n    id\n    amount\n    amountRefunded\n    chargeTotal\n    created\n    data\n    description\n    holdAmount\n    paymentIntentId\n    refundStatus\n    refunded\n    status\n    systemId\n    systemOldId\n    taxAmount\n    taxRate\n    userId\n    userOldId\n    walletId\n    organizationId\n    partnerCharge\n    user {\n      id\n      firstName\n      lastName\n      email\n      phone\n    }\n    system {\n      id\n      oldId\n      name\n    }\n    rental {\n      id\n    }\n    wallet {\n      id\n    }\n    walletTransaction {\n      id\n      oldId\n    }\n    refunds {\n      id\n      amount\n      createdOn\n      description\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bbee115cb7a8ff5323aebd0bcfcd8fae";

export default node;
